<div class="validate-diaries-page-container">
  <div class="page-card">
    <div class="page-card-header">
      <h1>Policy Code: {{ data.policyCode }}</h1>
      <button type="button" class="icon-button" aria-label="Close" (click)="dialogRef.close()">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="page-card-content">
      <aside class="diary-menu">
        <p-accordion [(value)]="panelOpenState">
          <p-accordion-panel [value]="0">
            <p-accordion-header>
              <span class="panel-title">
                <span class="material-icons">list_alt</span>
                <span>To do</span>
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <ul class="diary-list">
                @if (todoMenuLoading) {
                <div class="todo-menu-spinner">
                  <p-progressspinner ariaLabel="loading" />
                </div>
                }

                @for (diary of toDoDiaryList; track diary) {
                <li class="diary-list-item" (click)="getDocuments(diary)">
                  @if (!todoMenuLoading) {
                  <div class="diary-information">
                    <div>
                      <div class="item-title">
                        {{ getDocumentName(diary.id) }}
                      </div>
                      <div class="item-line">
                        {{ diary.id }}
                      </div>
                    </div>
                    <div class="reviewed-label">
                      @if (diary.status.approved) {
                      <span class="green" [pTooltip]="diary.reason" tooltipPosition="right">Accepted</span>
                      }
                      @if (diary.status.rejected) {
                      <span class="red" [pTooltip]="diary.reason" tooltipPosition="right">Rejected</span>
                      }
                    </div>
                  </div>
                  }
                </li>
                }
              </ul>
            </p-accordion-content>
          </p-accordion-panel>

          <p-accordion-panel [value]="1">
            <p-accordion-header>
              <span class="panel-title">
                <span class="material-icons">hourglass_empty</span>
                <span>Pending</span>
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <ul class="diary-list">
                @if (pendingDiaryList.length == 0) {
                <div>Nothing here!</div>
                }
                @for (diary of pendingDiaryList; track diary) {
                <li class="diary-list-item">
                  <div class="item-title">
                    {{ getDocumentName(diary.diaryTypeId || diary.id) }}
                  </div>
                  <div class="item-line">
                    {{ diary.id }}
                  </div>
                </li>
                }
              </ul>
            </p-accordion-content>
          </p-accordion-panel>

          <p-accordion-panel [value]="2">
            <p-accordion-header>
              <span class="panel-title">
                <span class="material-icons">check_circle</span>
                <span>Approved</span>
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <ul class="diary-list">
                @if (reviewedDiaryList.length == 0) {
                <div>Nothing here!</div>
                }
                @for (diary of reviewedDiaryList; track diary) {
                <li class="diary-list-item">
                  <div class="item-title">
                    {{ getDocumentName(diary.diaryTypeId || diary.id) }}
                  </div>
                  <div class="item-line">
                    {{ diary.id }}
                  </div>
                </li>
                }
              </ul>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </aside>

      <section class="preview-panel">
        @if (diaryInPreview != undefined) {
        <div class="preview-panel-header">
          <div class="preview-header">
            <h2 class="preview-title">{{ documentNameInPreview }}</h2>
            <div class="preview-subtitle">{{ diaryIdInPreview }}</div>
          </div>
          <div class="paging-info-container">
            @if (pageInPreview != -1) {
            <span>Document {{ pageInPreview + 1 }} of
              {{ diaryInPreview.docDetails.length }}</span>
            }
          </div>
          @if (pageInPreview != -1 && diaryInPreview.docDetails.length > 1) {
          <div class="preview-navigation-container">
            <button type="button" class="icon-button" (click)="previousDocument()" [disabled]="
                    pageInPreview == 0 && diaryInPreview.docDetails.length > 1
                  ">
              <span class="material-icons" aria-hidden="false" aria-label="Previous document">arrow_back_ios</span>
            </button>
            <button type="button" class="icon-button" (click)="nextDocument()" [disabled]="
                    pageInPreview == diaryInPreview.docDetails.length - 1 &&
                    diaryInPreview.docDetails.length > 1
                  ">
              <span class="material-icons" aria-hidden="false" aria-label="Next document">arrow_forward_ios</span>
            </button>
          </div>
          }
        </div>
        }
        <hr class="divider" />
        <div class="preview-container">
          @if (previewLoading) {
          <p-progressspinner ariaLabel="loading" />
          }

          @if (fileTypeInPreview == 'image' && !previewLoading) {
          <img [src]="fileInPreview" height="100%" style="--transform-flip: {{ flip }}; --transform-rotate: {{
                rotate + 'deg'
              }}; --transform-scale: {{ zoom }}" class="containerImg" alt="Preview file" />
          }

          @if (fileTypeInPreview == 'pdf' && !previewLoading) {
          <pdf-viewer style="--transform-flip: {{ flip }}" [src]="pdfInPreview" [render-text]="true"
            [original-size]="false" class="pdf-preview" [render-text-mode]="2" [rotation]="pdfRotateAngle" [zoom]="zoom"
            [fit-to-page]="true" [zoom-scale]="'page-fit'" [show-all]="true" [show-borders]="true"
            [stick-to-page]="true" [page]="pageNumber" [autoresize]="true"
            (after-load-complete)="callback($event)"></pdf-viewer>
          }
          @if (diaryInPreview === undefined && !previewLoading) {
          <span>No item selected</span>
          }
          @if (fileTypeInPreview == 'text' && !previewLoading) {
          <div class="text-preview-container">
            @for (item of textListInPreview; track item) {
            <span id="text-preview-item">
              {{ getItemName(item.key) | titlecase }} -
              {{ item.key == "lastInsuredDate" ? item.value : item.value }}
            </span>
            }
          </div>
          }
        </div>

        @if (diaryInPreview != undefined) {
        <div class="first-action-panel">
          <div class="operation-buttons">
            <span class="horizontal-separator"></span>
            <button type="button" pTooltip="zoom out" tooltipPosition="top" class="icon-button" aria-label="Zoom out"
              (click)="zoomOut()" [disabled]="zoom <= 0.5">
              <span class="material-icons">zoom_out</span>
            </button>
            <button type="button" pTooltip="restore zoom" tooltipPosition="top" class="icon-button"
              aria-label="Restore zoom" (click)="restoreZoom()" [disabled]="zoom == 1">
              <span class="material-icons">youtube_searched_for</span>
            </button>
            <button type="button" pTooltip="zoom in" tooltipPosition="top" class="icon-button" aria-label="Zoom in"
              (click)="zoomIn()">
              <span class="material-icons">zoom_in</span>
            </button>
            <span class="horizontal-separator"></span>
            @if (pageInPreview != -1) {
            <button type="button" pTooltip="rotate to left" tooltipPosition="top" class="icon-button"
              (click)="rotateToLeft()" [disabled]="previewRotate === -4">
              <span class="material-icons">rotate_left</span>
            </button>
            }
            @if (pageInPreview != -1) {
            <button type="button" pTooltip="rotate to right" tooltipPosition="top" class="icon-button"
              (click)="rotateToRight()" [disabled]="previewRotate === 4">
              <span class="material-icons">rotate_right</span>
            </button>
            }
            <span class="horizontal-separator"></span>
            <button type="button" pTooltip="mirror" tooltipPosition="top" class="icon-button" [class.accent]="flip != 1"
              aria-label="Mirror" (click)="mirror()">
              <span class="material-icons">flip</span>
            </button>
            <span class="horizontal-separator"></span>
            <span class="horizontal-separator"></span>
          </div>
          <div class="validation-buttons">
            <button type="button" class="green-button" (click)="acceptDocument()">
              Accept
            </button>
            <button type="button" class="red-button" (click)="rejectDocument()">
              Reject
            </button>
          </div>
        </div>
        }
      </section>
    </div>

    <hr class="divider" />
    <div class="second-action-panel">
      <p-button label="Download" severity="secondary" (onClick)="downloadNBPack()" [disabled]="!isDownloadEnabled" />
    </div>
  </div>

  @if (isDownloadInProgress) {
  <app-overlapping-spinner></app-overlapping-spinner>
  }
</div>

<p-dialog [(visible)]="showErrorDialog" [modal]="true" [closable]="false" [showHeader]="false">
  <div class="message-dialog-container">
    <div class="message-info">
      <h1 class="title">Oops... Something went wrong!</h1>
      <div class="message">
        Please try again in a few minutes or contact WebDev Team
      </div>
    </div>
    <div class="actions">
      <p-button label="Ok" (onClick)="showErrorDialog = false" />
    </div>
  </div>
</p-dialog>